// extracted by mini-css-extract-plugin
export var fullWidthButton = "_ri-0";